<script lang="ts">
  import type { Graph, WithContext, Thing } from 'schema-dts';
  import { browser } from '$app/environment';
  import getJsonLd from '$lib/getJsonLd';

  export let data: App.PageData;
  export let types: string[];

  let jsonLd: Graph | WithContext<Thing> | null = null;
  $: {
    jsonLd = browser ? null : getJsonLd(data, types);

    if (browser) {
      Promise.all([data.scope.data, data.scope.meta, data.scope.dataLayer])
        .then(([stream, meta, dataLayer]) => {
          const scope = {
            ...data.scope,
            data: stream,
            meta,
            dataLayer,
          };
          jsonLd = getJsonLd({ ...data, scope }, types);
        })
        .catch(() => (jsonLd = null));
    }
  }
</script>

{#if jsonLd}
  <!-- eslint-disable-next-line svelte/no-at-html-tags -->
  {@html '<scr' + 'ipt type="application/ld+json">' + JSON.stringify(jsonLd) + '</scr' + 'ipt>'}
{/if}
